<template>
  <div>
    <el-button type="primary" size="small" @click="handleEdit()" v-code="61202">
      添加{{ commodityCategory.name }}
    </el-button>
    <file-button
      v-if="userInfo.id == 2"
      obj="material"
      :exportButton="false"
      style="float: right"
      v-code="61101"
    ></file-button>
    <el-table :data="list">
      <el-table-column align="left" label="名称" prop="name"></el-table-column>
      <el-table-column
        align="left"
        label="存货编码"
        prop="code"
      ></el-table-column>
      <el-table-column
        align="left"
        label="规格"
        prop="specification"
      ></el-table-column>
      <el-table-column
        align="left"
        :label="commodityCategory.id == 2 ? '倒角' : '型号'"
        prop="model_number"
      ></el-table-column>
      <template v-if="commodityCategory.id == 2">
        <el-table-column
          align="left"
          label="齿形"
          prop="tooth_type"
        ></el-table-column>
        <el-table-column
          align="left"
          label="尺寸"
          prop="size"
        ></el-table-column>
      </template>
      <el-table-column
        align="center"
        label="计量单位"
        prop="unit"
      ></el-table-column>
      <!-- <el-table-column
        align="center"
        label="数量"
        prop="number"
      ></el-table-column> -->
      <!-- <el-table-column align="center" label="当前价格" prop="price">
        <template slot-scope="scope">
          {{ scope.row.price.toFixed(2) }}
        </template>
      </el-table-column> -->
      <el-table-column align="center" label="状态">
        <template slot-scope="scope">
          <el-link
            :type="scope.row.status == 1 ? 'success' : 'warning'"
            :underline="false"
          >
            {{ scope.row.status == 1 ? '启用' : '禁用' }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" min-width="120">
        <template slot-scope="scope">
          <el-popconfirm
            v-code="61205"
            title="确认删除该材料吗？"
            @confirm="handleDelete(scope.row.id, scope.$index)"
          >
            <el-link :underline="false" slot="reference" type="danger"
              >删除</el-link
            >
          </el-popconfirm>
          <el-popconfirm
            class="ml-10"
            v-code="61204"
            :title="`确认${scope.row.status == 1 ? '禁用' : '启用'}该材料吗？`"
            @confirm="handleSwitchStatus(scope.row.id, scope.$index)"
          >
            <el-link :underline="false" slot="reference" type="warning">{{
              scope.row.status == 1 ? '禁用' : '启用'
            }}</el-link>
          </el-popconfirm>
          <el-link
            v-code="61203"
            :underline="false"
            class="ml-10"
            type="primary"
            @click="handleEdit(scope.row, scope.$index)"
            >编辑</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <editor
      :model="model"
      :name="commodityCategory.name"
      :show.sync="formerVisible"
      @callback="callback"
    ></editor>
  </div>
</template>

<script>
import { commodityDelete, commoditySwitchStatus } from '@/service/getData'
import editor from './editor'
import { getStore } from '@/config/mUtils'

export default {
  components: {
    editor,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    commodityCategory: Object,
  },
  data() {
    return {
      userInfo: getStore('userInfo'),
      formerVisible: false,
      editIndex: -1,
      model: {
        category: 0,
        name: '',
        code: '',
        specification: '',
        model_number: '',
        unit: '',
        tooth_type: '',
        size: '',
      },
    }
  },
  methods: {
    handleEdit(item, index) {
      this.formerVisible = true
      this.$nextTick(() => {
        if (!item) {
          this.editIndex = -1
          this.model = {
            category: this.commodityCategory.id,
            name: this.commodityCategory.name,
            code: '',
            specification: '',
            model_number: '',
            unit: '',
            tooth_type: '',
            size: '',
          }
        } else {
          this.model = this.clone(item)
          this.editIndex = index
        }
      })
    },
    async handleDelete(id, index) {
      let res = await commodityDelete(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
    async handleSwitchStatus(id, index) {
      let res = await commoditySwitchStatus(id)
      if (res.code == 0) {
        this.$set(this.list, index, res.data)
      }
    },
    callback(data) {
      if (this.editIndex == -1) {
        this.list.unshift(data)
      } else {
        this.$set(this.list, this.editIndex, data)
      }
    },
  },
}
</script>